import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from '@wit-support/ui';
import { FieldShell } from './field-shell.js';
import { isStringFormat } from '../lib/walk-schema.js';
export function TextWidget(props) {
    const { field, fieldState, meta, schema, label, description, hint, readonly, disabled, name: _name, ...rest } = props;
    let type = 'text';
    if (isStringFormat(schema, 'email'))
        type = 'email';
    else if (isStringFormat(schema, 'url'))
        type = 'url';
    const value = field.value ?? '';
    return (_jsx(FieldShell, { meta: meta, fieldState: fieldState, label: label, description: description, hint: hint, htmlFor: field.name, children: _jsx(Input, { ...field, id: field.name, type: type, value: value, placeholder: meta.placeholder, readOnly: readonly ?? meta.readonly, disabled: disabled, ...rest }) }));
}
//# sourceMappingURL=text.js.map